import { CustomerProductList } from "@redotech/redo-model/customer-product-list/customer-product-list-definition";
import { z } from "zod";

export const createCustomerProductList = {
  input: z.null(),
  output: z.object({ customerProductList: CustomerProductList.optional() }),
};
